//import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Transition from './Dialogs/Transition';

const styles = {};

export default class ConfirmNotifierRunNowDialog extends Component {

	constructor (props) {
		super(props);
		this.state = {
			reason: '',
		};
		this.handleClose = this.handleClose.bind(this);
		this.handleRun = this.handleRun.bind(this);
	}

	onChange (event, fieldName) {
		this.setState({[fieldName]: event.target.value});
	}

	handleClose () {
		this.props.onClose();
	}

	handleRun () {
		this.props.runNotifier({
			params: {
				reason: this.state.reason,
			},
			callback: function (err) {
				if (!err) { this.props.onClose(); }
			}.bind(this)
		});
	}

	render () {
		return (
			<Dialog
				maxWidth='md'
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
			>
				<DialogTitle>
					Manually Run Notifier
				</DialogTitle>
				<DialogContent>
					<TextField
						style={styles.new}
						value={this.state.reason}
						onChange={event => this.onChange(event, 'reason')}
						label="Reason for manually running notifier"
						fullWidth
					/>

					<div style={{padding: 20, fontWeight: 900, fontSize: 18}}>
						Are you sure you want to run the notifier?
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleClose}>
						Close
					</Button>
					<Button variant="contained" onClick={this.handleRun} style={{backgroundColor: '#F44336', color: 'white'}}>
						Yes, run notifier
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

ConfirmNotifierRunNowDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	runNotifier : PropTypes.func.isRequired,
};